module.exports = __webpack_public_path__ + "static/media/pega_correta2.455d5461.jpg";